import axios from "axios";
import router from "../../router";
// axios.defaults.baseURL = process.env.VUE_APP_baseAPI;
//请求拦截器
axios.interceptors.request.use(
    config => {
        if (config.method === "get") {
            config.data = true;
        }
        const Token_type = localStorage.getItem("Token_type");
        const Access_token = localStorage.getItem("Access_token");
        config.headers.Authorization = Token_type + " " + Access_token;
        const dbKey = localStorage.getItem("DBKey");
        config.headers.cur_base_db_key = dbKey;
        return config;
    },
    error => {
        return Promise.error(error);
    }
);

// 响应拦截器
axios.interceptors.response.use(
    // 请求成功
    res => (res.status === 200 ? Promise.resolve(res) : Promise.reject(res)),
    // 请求失败
    error => {
        const { response } = error;
        if (response) {
            // 请求已发出，但是不在2xx的范围
            if (response.status === 401) {
                localStorage.removeItem("Token_type");
                localStorage.removeItem("Access_token");
                //token失效
                router.replace({
                    path: "/loginInvalid",
                    query: {
                        redirect: router.currentRoute.fullPath
                    }
                });
            }
            return Promise.reject(response);
        }
    }
);

export default axios;